<template>
  <div>
    <b-modal
      modal-class="modal-fullscreen p-0"
      id="upload-camera"
      ref="uploadCamera"
      hide-footer
      header-class="header-camera"
      @shown="toggleCamera">
      <template #modal-header="{ close }">
        <div class="pr-3 cursor-pointer">
          <b-icon icon="x" @click="close()" font-scale="2"></b-icon>
        </div>
      </template>
      <CameraComponent
        ref="cameraComponent"
        @save-picture="$emit('onSavePicture', $event)" />
    </b-modal>
  </div>
</template>

<script>
import CameraComponent from "@/components/CameraComponent.vue";
export default {
  props: {
    todoList: {
      type: Object,
    },
  },
  components: {
    CameraComponent,
  },
  methods: {
    async toggleCamera() {
      this.$refs.cameraComponent.toggleComponentVisibility();
    },
  },
};
</script>
